module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [(false) ? _c('div', {
    staticClass: "box-operate"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.subjectAdd
    }
  }, [_vm._v("新增项目")])], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('div', [_c('el-divider', [_vm._v("项目信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "项目",
        "prop": "name"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.openSubjectPicker(_vm.subjectOptionsAll, index)
        }
      }
    }, [_vm._v("请选择项目 "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.subject_name),
        expression: "subject.subject_name"
      }],
      staticClass: "form-label-desc"
    }, [_vm._v(_vm._s(subject.subject_name))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [(subject.subject_name.indexOf('活力大课间啦啦操展示') >= 0) ? _c('el-form-item', {
      attrs: {
        "label": "运动员人数"
      }
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "auto !important"
      },
      attrs: {
        "min": 0,
        "max": 3000
      },
      model: {
        value: (subject.yundongyuan_count),
        callback: function($$v) {
          _vm.$set(subject, "yundongyuan_count", $$v)
        },
        expression: "subject.yundongyuan_count"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" 如果不上传运动员信息，请填写运动员人数\n            ")], 1) : _vm._e(), _vm._v(" "), (subject.subject_name.indexOf('活力大课间啦啦操展示') >= 0) ? _c('el-form-item', {
      attrs: {
        "label": "参赛运动员"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          subject.showYundongyuanPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }, [_vm._v("方式1：手动选择已注册的运动员\n                "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })]), _vm._v(" "), _c('div', [_vm._v(" \n                  方式2：\n                  "), _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": _vm.download
      }
    }, [_vm._v("先下载导入模版")]), _vm._v(" "), _c('van-uploader', {
      attrs: {
        "accept": ".xls,.xlsx",
        "after-read": _vm.readFile
      }
    }, [_c('el-button', {
      attrs: {
        "size": "normal"
      },
      on: {
        "click": function($event) {
          _vm.thisSubjectIndex = index
        }
      }
    }, [_vm._v("再批量导入\n                    ")])], 1), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v("运动员姓名将显示在比赛证书上，"), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("请谨慎填写"), _c('br'), _vm._v("如果不填写运动员，后期将无法导出证书。")])])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.yundongyuan.length),
        expression: "subject.yundongyuan.length"
      }]
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', {
        key: index,
        staticClass: "memberLi"
      }, [_vm._v("\n                  运动员" + _vm._s(index + 1) + "\n                  "), _c('el-tag', {
        key: index,
        attrs: {
          "round": "",
          "closable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.yundongyuan.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(_vm._f("sex")(yundongyuan.sex)) + "\n                  ")])], 1)
    }), 0)]) : _c('el-form-item', {
      attrs: {
        "label": "参赛运动员"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          subject.showYundongyuanPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }, [_vm._v("选择运动员\n                "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.yundongyuan.length),
        expression: "subject.yundongyuan.length"
      }]
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', {
        key: index,
        staticClass: "memberLi"
      }, [_vm._v("\n                  运动员" + _vm._s(index + 1) + "\n                  "), _c('el-tag', {
        key: index,
        attrs: {
          "round": "",
          "closable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.yundongyuan.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(_vm._f("sex")(yundongyuan.sex)) + "\n                  ")])], 1)
    }), 0)])], 1)], 1), _vm._v(" "), (subject.music_url) ? _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "规定音乐"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.playMusicUrl = subject.music_url;
          subject.music_url_played = true;
          _vm.showMusic = true
        }
      }
    }, [_vm._v("点击试听 "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "替补运动员"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          subject.showTbYundongyuanPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }, [_vm._v("\n                请选择替补运动员 "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.tbydy.length),
        expression: "subject.tbydy.length"
      }]
    }, _vm._l((subject.tbydy), function(yundongyuan, index) {
      return _c('div', {
        key: index,
        staticClass: "memberLi"
      }, [_vm._v("\n                  替补运动员" + _vm._s(index + 1) + "\n                  "), _c('el-tag', {
        key: index,
        attrs: {
          "round": "",
          "closable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.tbydy.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(_vm._f("sex")(yundongyuan.sex)) + "\n                  ")])], 1)
    }), 0)])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "教练员"
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          subject.showJiaolianPicker = true;
          _vm.thisSubjectIndex = index
        }
      }
    }, [_vm._v("请选择教练员 "), _c('i', {
      staticClass: "el-icon-arrow-right"
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.jiaolian.length),
        expression: "subject.jiaolian.length"
      }]
    }, _vm._l((subject.jiaolian), function(yundongyuan, index) {
      return _c('div', {
        key: index,
        staticClass: "memberLi"
      }, [_vm._v("\n                  教练员" + _vm._s(index + 1) + "\n                  "), _c('el-tag', {
        key: index,
        attrs: {
          "round": "",
          "closable": "",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.jiaolian.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n                  ")])], 1)
    }), 0), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": "28px",
        "padding-top": "10px",
        "font-size": "14px",
        "color": "#666"
      }
    }, [_vm._v("此处教练员顺序即为获奖证书的教练员顺序 "), _c('span', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("请谨慎选择")])])])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "tc"
    }, [_c('el-button', {
      attrs: {
        "type": "default",
        "icon": "el-icon-delete",
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.subjectRemove(subject, index)
        }
      }
    }, [_vm._v("\n            删除项目" + _vm._s(index + 1) + "\n          ")])], 1), _vm._v(" "), _c('YundongyuanPicker', {
      attrs: {
        "show": subject.showYundongyuanPicker,
        "limit": 10000,
        "defaultValue": subject.yundongyuan
      },
      on: {
        "onChange": _vm.onYundongyuanChange,
        "onClose": function($event) {
          subject.showYundongyuanPicker = false
        },
        "onConfirm": _vm.onYundongyuanConfirm
      }
    }), _vm._v(" "), (_vm.row.subject_list.length > 0) ? _c('YundongyuanPicker', {
      attrs: {
        "show": subject.showTbYundongyuanPicker,
        "limit": 10000,
        "defaultValue": subject.tbydy
      },
      on: {
        "onChange": _vm.onTbYundongyuanChange,
        "onClose": function($event) {
          subject.showTbYundongyuanPicker = false
        },
        "onConfirm": _vm.onTbYundongyuanConfirm
      }
    }) : _vm._e(), _vm._v(" "), _c('SubjectJiaolianPicker', {
      attrs: {
        "show": subject.showJiaolianPicker,
        "limit": 5,
        "options": _vm.row.jiaolian_options,
        "defaultValue": subject.jiaolian
      },
      on: {
        "onChange": _vm.onJiaolianChange,
        "onClose": function($event) {
          subject.showJiaolianPicker = false
        },
        "onConfirm": _vm.onJiaolianConfirm
      }
    })], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "default",
      "plain": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.subjectAdd
    }
  }, [_vm._v("新增项目")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitCheck('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")]), _vm._v(" "), (false) ? _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("重置")]) : _vm._e()], 1)], 1)], 2), _vm._v(" "), _c('van-popup', {
    style: ({
      width: '60%',
      paddingTop: '50px'
    }),
    on: {
      "click-overlay": _vm.onSubjectClose
    },
    model: {
      value: (_vm.showSubjectPicker),
      callback: function($$v) {
        _vm.showSubjectPicker = $$v
      },
      expression: "showSubjectPicker"
    }
  }, [_c('van-cell-group', _vm._l((_vm.subjectOptions), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.onSubjectSelect(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "音乐播放",
      "visible": _vm.showMusic
    },
    on: {
      "update:visible": function($event) {
        _vm.showMusic = $event
      },
      "close": function($event) {
        _vm.showMusic = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.playMusicUrl && _vm.showMusic) ? _c('audio', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "autoplay": "",
      "src": _vm.playMusicUrl,
      "controls": "controls"
    }
  }) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b884d7a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep2.vue
// module id = 1582
// module chunks = 0